import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import "vant/lib/index.css";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
// 加载css
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
import http from "@/utils/request.js";
Vue.prototype.$axios = http;
import VueLazyload from "vue-lazyload";
import "@/utils/rem.js";
// import "@/icons";
// import 'lib-flexible/flexible.js'
import "@/assets/lib/iconfont.css"; // iconfont
import api from "./utils/api";
//视频
import Video from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = Video;
Vue.prototype.$url = process.env.VUE_APP_SERVICE_URL
// 时间格式处理
import moment from "moment";
Vue.prototype.$moment = moment;

import 'jquery'
//接口
Vue.prototype.$api = api;
import {
  formPost,
  resPost,
  blobGet,
  blobPost,
  resGet,
  multPost,
  allPost,
} from "./utils/http";
Vue.prototype.$formPost = formPost;
Vue.prototype.$resPost = resPost;
Vue.prototype.$blobGet = blobGet;
Vue.prototype.$blobPost = blobPost;
Vue.prototype.$resGet = resGet;
Vue.prototype.$multPost = multPost;
Vue.prototype.$allPost = allPost;

// 高德地图
import AMap from "vue-amap";
Vue.use(AMap);
AMap.initAMapApiLoader({
  key: "9b2e894d614834e9de5b687446418fb2",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geolocation",
  ],
  v: "1.4.4",
});
Vue.use(Vant);
Vue.use(VueLazyload);
Vue.config.productionTip = false;
// Vue.prototype.domain = 'http://121.41.103.74:8090'
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
